import { render, staticRenderFns } from "./add-notes.vue?vue&type=template&id=09f784fa&scoped=true"
import script from "./add-notes.vue?vue&type=script&lang=js"
export * from "./add-notes.vue?vue&type=script&lang=js"
import style0 from "./add-notes.vue?vue&type=style&index=0&id=09f784fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f784fa",
  null
  
)

export default component.exports